import {
  DOC_TYPE_FILED_COPIES,
  DOC_TYPE_K1_PACKAGE,
  resolveDocumentModalContextTab,
  resolveStaffDocTypeFromPurpose,
} from "./moveDocumentScope";
import { SERVICE_COMPLETED_STATUS } from "../constants/clientServiceOptions";
import { CUSTOM_FILED_COPIES_DOCUMENT_TAG } from "../constants/filedCopiesDocumentTags";

export function isFiledCopiesUploadModal(modalId) {
  return (
    modalId === "filed_copies_upload" || modalId === "k1_package_upload"
  );
}

export function isFolderUploadModal(modalId) {
  const modal = String(modalId || "");
  return modal === "emp_upload" || modal.includes("add_folder_upload");
}

export function resolveUploadDocTypeFromModal({
  modalId,
  isClient = false,
  purposeTab,
  folderModalContext,
}) {
  const modal = String(modalId || "");
  if (modal === "client_upload") return "client";
  if (modal === "office_upload") return "office";
  if (modal === "k1_package_upload") return DOC_TYPE_K1_PACKAGE;
  if (modal === "filed_copies_upload") return DOC_TYPE_FILED_COPIES;
  if (isFolderUploadModal(modal)) {
    if (isClient) return "emp";
    const contextTab = resolveDocumentModalContextTab(
      purposeTab,
      folderModalContext,
    );
    return resolveStaffDocTypeFromPurpose(contextTab);
  }
  if (isClient) return "emp";
  return resolveStaffDocTypeFromPurpose(
    resolveDocumentModalContextTab(purposeTab, folderModalContext),
  );
}

export function shouldShowFiledCopiesTagPicker(options = {}) {
  const modal = String(options.modalId || "");
  if (!modal.includes("_upload")) return false;
  return requiresFiledCopiesDocumentTag(resolveUploadDocTypeFromModal(options));
}

export function requiresFiledCopiesDocumentTag(docType) {
  const normalized = String(docType || "").toLowerCase();
  return (
    normalized === DOC_TYPE_FILED_COPIES || normalized === DOC_TYPE_K1_PACKAGE
  );
}

export function appendFiledCopiesTagsToFormData(formData, files, tags) {
  if (!formData || !Array.isArray(files) || !files.length) return;
  const metadata = files.map((file, index) => ({
    file_name: file?.name || "",
    document_tag: String(tags?.[index] || "").trim(),
  }));
  formData.append("file_metadata", JSON.stringify(metadata));
}

export function appendFiledCopiesServiceToFormData(formData, clientServiceId) {
  if (!formData) return;
  const id = String(clientServiceId || "").trim();
  if (!id) return;
  formData.append("client_service_id", id);
}

export function validateFiledCopiesServiceSelection(clientServiceId) {
  if (!String(clientServiceId || "").trim()) {
    return "Please select a service";
  }
  return null;
}

export function validateFiledCopiesUpload({
  files,
  tags,
  clientServiceId,
  requireService = false,
}) {
  const tagError = validateFiledCopiesUploadTags(files, tags);
  if (tagError) return tagError;
  if (requireService) {
    const serviceError = validateFiledCopiesServiceSelection(clientServiceId);
    if (serviceError) return serviceError;
  }
  return null;
}

export async function markFiledCopiesServiceCompleted({
  updateClientServiceStatus,
  clientId,
  clientServiceId,
}) {
  const serviceId = String(clientServiceId || "").trim();
  const client_id = String(clientId || "").trim();
  if (!serviceId || !client_id || typeof updateClientServiceStatus !== "function") {
    return { status: 0, message: "Missing service or client" };
  }
  return updateClientServiceStatus({
    client_id,
    client_service_id: serviceId,
    status: SERVICE_COMPLETED_STATUS,
  });
}

export function validateFiledCopiesUploadTags(files, tags) {
  if (!files?.length) {
    return "Please upload document";
  }
  if (!Array.isArray(tags) || tags.length !== files.length) {
    return "Please select a document tag for each file";
  }
  if (tags.some((tag) => {
    const value = String(tag || "").trim();
    return !value || value === CUSTOM_FILED_COPIES_DOCUMENT_TAG;
  })) {
    return "Please select a document tag for each file";
  }
  return null;
}

export function emptyTagsForFileCount(count) {
  return Array.from({ length: Math.max(0, count) }, () => "");
}
